module.exports = __webpack_public_path__ + "img/pg3-article2.38b72f0c.png";